import { NirvanaSanitizedError } from './errors';

export enum EventType {
  STREAM_MESSAGE = 'stream-message',
  RPC_JSON_REQUEST = 'rpc-json',
  RPC_JSON_RESPONSE = 'rpc-json-response',
  STREAM_START = 'stream-start',
  RATE_LIMIT = 'rate-limit',
}

export const EventTypeValues = Object.values(EventType);

export enum StreamMessageType {
  STREAM_START = 'streamStart',
  STREAM_READY = 'streamReady',
  STREAM_STOP = 'streamStop',
  STREAM_HEART_BEAT = 'streamHeartBeat',
  STREAM_DELIVERY_FAILED = 'streamDeliveryFailed',
  STREAM_ERROR = 'streamError',
  DATA = 'data',
  RESIZE = 'resize',
}

export enum StreamStopReason {
  UNKNOWN = 0,
  ON_DEMAND = 1,
  INACTIVITY = 2,
  NO_MORE_DATA = 3,
}

export const StreamStopReasonValues = Object.values(StreamStopReason);

export enum ClientType {
  GZ_CONSOLE = 'gz-console',
  ENDPOINT = 'endpoint',
  INTERNAL = 'gz-internal',
}

export interface RpcRequest<T = any> {
  jsonrpc: string;
  id: string;
  params?: T;
  method: string;
}

export interface RpcResponse<T = any> {
  jsonrpc: string;
  id: string;
  result?: T;
  error?: NirvanaSanitizedError;
}

export interface StreamStartRequest {
  streamId: string;
  method: string;
  payload: any;
}

export type Trace = TraceItem[];

export interface TraceItem {
  clientId: string;
  clientName: string;
}

export const DEFAULT_SIZE = {
  cols: 80,
  rows: 24,
};
